__turbopack_context__.v({
  "cell": "dynamictable-module-scss-module__9gZHYa__cell",
  "cellLabel": "dynamictable-module-scss-module__9gZHYa__cellLabel",
  "label": "dynamictable-module-scss-module__9gZHYa__label",
  "mobileCell": "dynamictable-module-scss-module__9gZHYa__mobileCell",
  "mobileRow": "dynamictable-module-scss-module__9gZHYa__mobileRow",
  "mobileTable": "dynamictable-module-scss-module__9gZHYa__mobileTable",
  "row": "dynamictable-module-scss-module__9gZHYa__row",
  "table": "dynamictable-module-scss-module__9gZHYa__table",
});
